// Static content aligned with rsconstructionhi.co.uk
// Business contact info is dynamic and managed via /admin → Business Info

export const HERO_LINES = [
  { eyebrow: "RS Construction (HI) Ltd", big: "Bespoke construction.", italic: "Built without compromise." },
];

// Premium cinematic hero — dark architectural photography (overlay-friendly so nav stays readable)
export const HERO_SLIDES = [
  "https://images.unsplash.com/photo-1503387762-592deb58ef4e?crop=entropy&cs=srgb&fm=jpg&q=90&w=2400",
  "https://images.unsplash.com/photo-1486325212027-8081e485255e?crop=entropy&cs=srgb&fm=jpg&q=90&w=2400",
  "https://images.unsplash.com/photo-1572883454114-1cf0031ede2a?crop=entropy&cs=srgb&fm=jpg&q=90&w=2400",
];

// Reliable hotlinkable construction footage with image fallback
export const HERO_VIDEO = "https://cdn.pixabay.com/video/2020/10/19/52571-471697007_large.mp4";
export const HERO_VIDEO_ALT = "https://cdn.pixabay.com/video/2024/03/19/204062-925251577_large.mp4";
// Cinematic dark-toned poster — guarantees navbar contrast even before video loads
export const HERO_POSTER = "https://images.unsplash.com/photo-1503387762-592deb58ef4e?crop=entropy&cs=srgb&fm=jpg&q=90&w=2400";

export const MANIFESTO = [
  "From planning to completion.",
  "Precision · Reliability · Expertise.",
  "Trusted partner for every build.",
  "Bespoke for the discerning client.",
];

// 7 ACTUAL services from rsconstructionhi.co.uk/pages/services
export const SERVICES = [
  {
    slug: "design-planning",
    number: "01",
    title: "Design & Planning",
    short: "Design & Planning",
    tag: "Pre-Build",
    image: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?crop=entropy&cs=srgb&fm=jpg&q=90&w=1600",
    blurb: "Get expert guidance before you start your project — we help you plan layouts, choose the right materials, and prepare for a successful build.",
    long: "Our Design & Planning service is the foundation of every successful project. We sit with you to understand your vision, draft layouts, specify the right materials, navigate planning permissions, and produce a clear, costed roadmap before a single tool is picked up. The result is fewer surprises, tighter budgets, and a build that runs to schedule.",
    bullets: [
      "Site survey & feasibility study",
      "Layout drawings & material specification",
      "Planning-permission & building-regs guidance",
      "Itemised costed proposal",
    ],
  },
  {
    slug: "installation",
    number: "02",
    title: "Installation Services",
    short: "Installation",
    tag: "On-Site",
    image: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?crop=entropy&cs=srgb&fm=jpg&q=90&w=1600",
    blurb: "Professional installation support for tools, fixtures and fittings — from kitchens and bathrooms to full structural elements.",
    long: "Our installers are time-served tradespeople — joiners, plumbers, electricians and tilers — backed by a project manager who runs the schedule. Whether it's a single fixture or a complete fit-out, every installation is left tidy, tested and warrantied.",
    bullets: [
      "Kitchens, bathrooms & wet-rooms",
      "Doors, windows & glazing",
      "Worktops, tiling & joinery",
      "All trades certified & insured",
    ],
  },
  {
    slug: "energy-improvement",
    number: "03",
    title: "Energy Improvement",
    short: "Energy Improvement",
    tag: "Sustainable",
    image: "https://images.unsplash.com/photo-1509391366360-2e959784a276?crop=entropy&cs=srgb&fm=jpg&q=90&w=1600",
    blurb: "Upgrade your space with energy-efficient solutions — insulation, glazing, heating and renewables that lower bills and lift EPC ratings.",
    long: "We retrofit British homes and small commercial spaces for a low-carbon future — from cavity-wall and loft insulation to A-rated double-glazing, heat pumps, solar PV and battery storage. Every job comes with EPC modelling so you can see the impact before you invest.",
    bullets: [
      "Insulation & draught-proofing",
      "A-rated glazing & doors",
      "Air-source heat pumps",
      "Solar PV & battery storage",
    ],
  },
  {
    slug: "finance-payment",
    number: "04",
    title: "Finance & Payment",
    short: "Finance",
    tag: "Flexible",
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&q=90&w=1600",
    blurb: "Flexible payment options that make purchases and projects more affordable — staged payments, interest-free instalments and trade accounts.",
    long: "We partner with FCA-regulated lenders to offer transparent finance on larger projects and material purchases. Choose from interest-free instalments on tools, staged build-payments aligned to milestones, or open a trade account with 30-day terms.",
    bullets: [
      "Interest-free instalments (subject to status)",
      "Stage payments aligned to milestones",
      "Trade accounts with 30-day terms",
      "Transparent, FCA-regulated lending",
    ],
  },
  {
    slug: "hire",
    number: "05",
    title: "Hire Services",
    short: "Hire",
    tag: "Tools & Plant",
    image: "https://images.unsplash.com/photo-1581094271901-8022df4466f9?crop=entropy&cs=srgb&fm=jpg&q=90&w=1600",
    blurb: "Access professional-grade tools and equipment on rent — daily, weekly or monthly — without the cost of buying outright.",
    long: "Our hire fleet covers everything from cordless drills and SDS hammers to scaffolding, mini-excavators and access platforms. Every machine is PAT-tested, serviced between hires and delivered to your site within 24 hours.",
    bullets: [
      "Power tools & cordless platforms",
      "Access towers & scaffolding",
      "Mini-excavators & breakers",
      "Same-day & next-day delivery",
    ],
  },
  {
    slug: "waste-disposal",
    number: "06",
    title: "Waste Disposal",
    short: "Waste Disposal",
    tag: "Compliant",
    image: "https://images.unsplash.com/photo-1611273426858-450d8e3c9fce?crop=entropy&cs=srgb&fm=jpg&q=90&w=1600",
    blurb: "Safe, responsible disposal of construction and DIY waste — skips, grab-lorries and full site clearance, fully licensed and traceable.",
    long: "We are a registered waste carrier (Tier 2) — every load is weighed, ticketed and consigned to a licensed transfer station. Choose from 4–12 yard skips, RoRo containers, grab-lorries or supplied-and-fitted clearance for full builds.",
    bullets: [
      "4–12 yard skips & RoRo containers",
      "Grab-lorry & wait-and-load",
      "Hazardous & asbestos consignment",
      "Full duty-of-care documentation",
    ],
  },
  {
    slug: "specialist-interior",
    number: "07",
    title: "Specialist Interior",
    short: "Specialist Interior",
    tag: "Finishing",
    image: "https://images.unsplash.com/photo-1600210492493-0946911123ea?crop=entropy&cs=srgb&fm=jpg&q=90&w=1600",
    blurb: "Expert services for finishing and improving your living space — plastering, decorating, fitted joinery and bespoke storage.",
    long: "When the structural work is done, our specialist finishers take over — wet-plastering to a polished finish, hand-painted in-frame joinery, made-to-measure wardrobes and feature panelling. The detail that turns a build into a home.",
    bullets: [
      "Wet plastering & decorative finishes",
      "Bespoke fitted joinery",
      "Wardrobes, alcoves & panelling",
      "Specialist paintwork & wallpaper",
    ],
  },
];

// Project gallery — kept curated and representative of our actual service categories
export const PROJECTS = [
  { id: 1, title: "Mayfair Heritage Renovation", category: "Specialist Interior", location: "Mayfair, W1", year: "2025", scope: "Full interior finishing · plastering · joinery",
    hero: "https://images.unsplash.com/photo-1600210492493-0946911123ea?crop=entropy&cs=srgb&fm=jpg&q=90&w=2000",
    thumb: "https://images.unsplash.com/photo-1600210492493-0946911123ea?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400" },
  { id: 2, title: "Chelsea Kitchen Installation", category: "Installation", location: "Chelsea, SW3", year: "2025", scope: "Bespoke kitchen install · stone worktops",
    hero: "https://images.pexels.com/photos/20653872/pexels-photo-20653872.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=2000",
    thumb: "https://images.pexels.com/photos/20653872/pexels-photo-20653872.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1400" },
  { id: 3, title: "Hampstead Loft Conversion", category: "Design & Planning", location: "Hampstead, NW3", year: "2024", scope: "Full design · planning · structural",
    hero: "https://images.unsplash.com/photo-1504624720567-64a41aa25d70?crop=entropy&cs=srgb&fm=jpg&q=90&w=2000",
    thumb: "https://images.unsplash.com/photo-1504624720567-64a41aa25d70?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400" },
  { id: 4, title: "Notting Hill Energy Retrofit", category: "Energy Improvement", location: "Notting Hill, W11", year: "2025", scope: "Insulation · glazing · ASHP",
    hero: "https://images.pexels.com/photos/9875685/pexels-photo-9875685.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=2000",
    thumb: "https://images.pexels.com/photos/9875685/pexels-photo-9875685.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1400" },
  { id: 5, title: "Islington Open-Plan Build", category: "Installation", location: "Islington, N1", year: "2024", scope: "Side-return · structural · finishes",
    hero: "https://images.pexels.com/photos/9757618/pexels-photo-9757618.png?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=2000",
    thumb: "https://images.pexels.com/photos/9757618/pexels-photo-9757618.png?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1400" },
  { id: 6, title: "Richmond Solar & Battery", category: "Energy Improvement", location: "Richmond, TW10", year: "2025", scope: "8kW PV · 10kWh battery storage",
    hero: "https://images.pexels.com/photos/9875683/pexels-photo-9875683.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=2000",
    thumb: "https://images.pexels.com/photos/9875683/pexels-photo-9875683.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1400" },
  { id: 7, title: "Kensington Master Bath Fit-Out", category: "Specialist Interior", location: "Kensington, W8", year: "2025", scope: "Tanked wet-room · book-matched marble",
    hero: "https://images.unsplash.com/photo-1696987007764-7f8b85dd3033?crop=entropy&cs=srgb&fm=jpg&q=90&w=2000",
    thumb: "https://images.unsplash.com/photo-1696987007764-7f8b85dd3033?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400" },
  { id: 8, title: "Surrey Plant-Hire Programme", category: "Hire", location: "Cobham, Surrey", year: "2024", scope: "12-month plant + tool hire schedule",
    hero: "https://images.unsplash.com/photo-1581094271901-8022df4466f9?crop=entropy&cs=srgb&fm=jpg&q=90&w=2000",
    thumb: "https://images.unsplash.com/photo-1581094271901-8022df4466f9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400" },
  { id: 9, title: "Primrose Hill Plaster & Decoration", category: "Specialist Interior", location: "Primrose Hill, NW1", year: "2025", scope: "Lime plaster · decorative finishes",
    hero: "https://images.pexels.com/photos/33685855/pexels-photo-33685855.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=2000",
    thumb: "https://images.pexels.com/photos/33685855/pexels-photo-33685855.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1400" },
  { id: 10, title: "Shoreditch Strip-Out & Disposal", category: "Waste Disposal", location: "Shoreditch, E1", year: "2024", scope: "RoRo · grab-lorry · full clearance",
    hero: "https://images.unsplash.com/photo-1611273426858-450d8e3c9fce?crop=entropy&cs=srgb&fm=jpg&q=90&w=2000",
    thumb: "https://images.unsplash.com/photo-1611273426858-450d8e3c9fce?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400" },
  { id: 11, title: "Fulham Stage-Payment Build", category: "Finance", location: "Fulham, SW6", year: "2025", scope: "Staged finance · 8-month build",
    hero: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&q=90&w=2000",
    thumb: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400" },
  { id: 12, title: "Dulwich Insulation Upgrade", category: "Energy Improvement", location: "Dulwich, SE21", year: "2025", scope: "Cavity-wall · loft · A-rated glazing",
    hero: "https://images.unsplash.com/photo-1509391366360-2e959784a276?crop=entropy&cs=srgb&fm=jpg&q=90&w=2000",
    thumb: "https://images.unsplash.com/photo-1509391366360-2e959784a276?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400" },
];

export const PROJECT_CATEGORIES = [
  "All",
  "Design & Planning",
  "Installation",
  "Energy Improvement",
  "Specialist Interior",
  "Hire",
  "Waste Disposal",
  "Finance",
];

// REAL testimonials from rsconstructionhi.co.uk
export const TESTIMONIALS = [
  {
    id: 1, name: "Sarah & James", role: "Homeowners", project: "Home renovation", rating: 5,
    title: "Excellent service",
    text: "The team delivered exceptional results on our home renovation. Their attention to detail and professionalism exceeded our expectations. We couldn't be happier with the quality of work and would highly recommend them to anyone looking for reliable construction services.",
  },
  {
    id: 2, name: "Mark & Olivia", role: "Homeowners", project: "Kitchen renovation", rating: 5,
    title: "Professional team",
    text: "From start to finish, the RS team was professional, punctual, and incredibly skilled. They transformed our outdated kitchen into a modern masterpiece. The project was completed on time and within budget. Highly recommended for any construction project.",
  },
  {
    id: 3, name: "The Hartleys", role: "Homeowners", project: "Home extension", rating: 5,
    title: "Outstanding quality",
    text: "We hired RS Construction for a complete home extension and the results are outstanding. The craftsmanship is top-notch and they were always available to answer our questions. The entire process was smooth and stress-free. We're thrilled with our new space.",
  },
  {
    id: 4, name: "D. Mitchell Ltd", role: "Commercial client", project: "Commercial fit-out", rating: 5,
    title: "Highly recommended",
    text: "The team handled our commercial building project with expertise and efficiency. Their team coordinated everything perfectly and delivered exceptional results. The quality of their work speaks for itself. We will definitely use their services again.",
  },
];

export const STATS = [
  { value: 25, suffix: "+", label: "Years Building" },
  { value: 1200, suffix: "+", label: "Projects Delivered" },
  { value: 98, suffix: "%", label: "On-Time Completion" },
  { value: 340, suffix: "+", label: "5-Star Reviews" },
];

export const PROCESS = [
  { step: "01", title: "Consultation", desc: "A relaxed on-site visit to understand your vision, budget and timeline. No obligation, no jargon." },
  { step: "02", title: "Design & Planning", desc: "We draft layouts, specify materials, and produce a clear costed proposal before work begins." },
  { step: "03", title: "Build & Install", desc: "A dedicated project manager, weekly progress reports and trusted trades from first-fix to finish." },
  { step: "04", title: "Handover", desc: "Full snagging walk-through, warranty documentation and aftercare on every completed project." },
];

// Three real principles from the website header strip
export const PRINCIPLES = [
  { t: "Outstanding service", d: "A senior contact on every project." },
  { t: "Exclusive pricing", d: "Trade-account terms passed on to you." },
  { t: "Industry expertise", d: "Time-served craft, certified trades." },
];

export const CREDENTIALS = [
  "Fast Delivery", "Easy Returns", "Trusted Quality",
  "FMB Member", "TrustMark", "Gas Safe",
  "NICEIC", "Tier-2 Waste Carrier",
];

export const AREAS = [
  "Greetland",
  "West Vale",
  "Elland",
  // "Halifax",
  "Sowerby Bridge",
  "Brighouse",
  "Huddersfield",
  "Hebden Bridge",
  "Todmorden",
  // "Mytholmroyd",
  // "Ripponden",
  "Rastrick",
  "Hipperholme",
  "Shelf",
  "Lightcliffe",
  // "Barkisland",
  "Stainland",
  // "Holywell Green",
  "Southowram",
  "Northowram",
  "Queensbury",
  "Bradford",
  "Leeds",
  // "Wakefield",
  "Dewsbury",
  // "Batley",
  "Mirfield",
  // "Cleckheaton",
  // "Heckmondwike",
  // "Keighley",
  // "Pudsey",
  "Morley",
  "Rochdale",
  "Oldham",
  // "Bury",
  "Bolton",
  "Manchester",
  "Salford",
  "Stockport",
  // "Wigan",
  "Warrington",
  "Liverpool",
  "Sheffield",
  "Barnsley",
  // "Doncaster",
  "Rotherham",
  "York",
  // "Harrogate",
  "Middlesbrough",
  "Preston",
  "Blackburn",
  "Burnley",
  "Blackpool",
  "Chester",
  "Nottingham",
  "Derby",
  "Leicester",
  "Birmingham",
  "Coventry",
  "Wolverhampton",
  // "Stoke-on-Trent",
  "Leeds City Region",
  "West Yorkshire",
  "Greater Manchester",
  "South Yorkshire",
  "Lancashire",
  "North Yorkshire",
  "Across the UK"
];

// REAL FAQs from rsconstructionhi.co.uk
export const FAQS = [
  { q: "How long does delivery take?", a: "Orders are processed within 1–3 business days. Delivery typically takes 3–7 business days for local orders and 7–15 business days for international orders." },
  { q: "Do you offer free shipping?", a: "Yes, we offer free shipping on orders over £1000. Shipping costs for smaller orders are calculated at checkout." },
  { q: "What is your return policy?", a: "You can request a return within 14 days of receiving your item, provided it is unused and in its original condition." },
  { q: "How do I request a refund?", a: "Simply contact our support team with your order details, and we will guide you through the process." },
  { q: "Is my payment information secure?", a: "Yes, we use secure payment gateways and encryption to ensure your personal and payment information is protected." },
];
